import * as Raven from "raven-js";

export const initializeSentry = () => {
  if (Raven.isSetup()) return;
  Raven.config(
    "https://0faff41c1ec14c31b94fda08c998f4a2@sentry.ff.avast.com/465"
  ).install();
};
